import React, { useContext } from 'react'
import { ThemeContext } from '../components/Context'
import { Link } from 'react-router-dom'
import axios from 'axios';
import { MdDeleteOutline } from "react-icons/md";
import { useState } from 'react';


const Blog = () => {
    const { blogs, api, setNotification } = useContext(ThemeContext)

    const [formData, setFormData] = useState({
        title: '',
        location: '',
        image: null,
        description: '',
        tags: '',
        reporter: '',
    })

    const handleChange = (e) => {
        const { name, value, files } = e.target
        if (name === 'image') {
            setFormData((prev) => ({ ...prev, image: files[0] }))
        } else {
            setFormData((prev) => ({ ...prev, [name]: value }))
        }
    }

    const addBlog=async(e)=>{
        e.preventDefault()
        try {
            const newData= new FormData()
            newData.append('title', formData.title)
            newData.append('description', formData.description)
            newData.append('reporter', formData.reporter)
            newData.append('tags', formData.tags)
            newData.append('location', formData.location)
            newData.append('image', formData.image)
            const response= await axios.post(`${api}/blog/new`, newData, {withCredentials:true})
            setNotification(response.data.message)
        } catch (error) {
            console.log(error.response.data.error)
            setNotification(error.response.data.message)
        }
    }


    const deleteBlog= async(id)=>{
        try {
            const response= await axios.delete(`${api}/blog/remove`, {data: {id}, withCredentials: true})
            setNotification(response.data.message)
        } catch (error) {
            setNotification(error.response.data.message)
        }
    }

    return (
        <div className='w-full flex flex-col items-center justify-center gap-6'>
            <form onSubmit={addBlog} className='w-full flex flex-col items-start justify-center gap-4 bg-white p-3 rounded-lg'>
                <h1 className='w-full text-2xl font-semibold text-center'>Add latest blog</h1>
                <div className='w-full flex flex-col items-start justify-center gap-2 '>
                    <label htmlFor="title">Tilte</label>
                    <input type="text" name='title' id='title' required onChange={handleChange} value={formData.title} className='w-full px-4 p-2 border-2 outline-none' />
                </div>
                <div className='w-full flex flex-col items-start justify-center gap-2 '>
                    <label htmlFor="location">Location</label>
                    <input type="text" name='location' id='location' required  onChange={handleChange} value={formData.location}  className='w-full px-4 p-2 border-2 outline-none' />
                </div>
                <div className='w-full flex flex-col items-start justify-center gap-2 '>
                    <label htmlFor="image">Image</label>
                    <input type="file" name='image' id='image' accept='image/*' required onChange={handleChange} className='w-full px-4 p-2 border-2 outline-none' />
                </div>
                <div className='w-full flex flex-col items-start justify-center gap-2 '>
                    <label htmlFor="description">Description</label>
                    <textarea name="description" id="description"  onChange={handleChange} value={formData.description}  className='w-full px-4 p-2 border-2 outline-none resize-none' ></textarea>
                </div>
                <div className='w-full flex flex-col items-start justify-center gap-2 '>
                    <label htmlFor="tags">Tags</label>
                    <input type="text" name='tags' id='tags' required  onChange={handleChange} value={formData.tags} className='w-full px-4 p-2 border-2 outline-none' placeholder='add (,) between tags' />
                </div>
                <div className='w-full flex flex-col items-start justify-center gap-2 '>
                    <label htmlFor="reporter">Reporter</label>
                    <input type="text" name='reporter' id='reporter' required  onChange={handleChange} value={formData.reporter}  className='w-full px-4 p-2 border-2 outline-none' />
                </div>
                <button type='submit' className='w-full bg-sky-400 p-1'>Submit</button>
            </form>


            <div className='w-full flex flex-col itemc justify-center gap-4 bg-white py-4 rounded-lg px-1'>
                <h1 className='w-full text-center font-semibold text-2xl'>Total blogs : {blogs.length}</h1>
                <div className='w-full flex flex-row items-center justify-between gap-1'>
                    <p className='w-full'>Title</p>
                    <p className='w-full md:flex hidden'>Description</p>
                    <p>Action</p>

                </div>
                {
                    blogs.length > 0 ? <div className='w-full flex flex-col items-center justify-center gap-4'>
                        {
                            blogs.map((blog) => {
                                const { title, description, _id } = blog
                                return <div key={_id} className='w-full flex flex-row items-center justify-between gap-1'>
                                    <Link className='w-full font-semibold' to={`/blogs/${title}`}>{title.slice(0, 20)} <span className='font-light'>...more</span></Link>
                                    <p className='w-full md:flex hidden' >{description.slice(0, 20)}....</p>
                                    <button onClick={()=>deleteBlog(_id)}><MdDeleteOutline /></button>
                                </div>
                            })
                        }
                    </div> : <p>No blog data found</p>
                }

            </div>

        </div>
    )
}

export default Blog
